import * as React from 'react';
import type { QueryResult } from 'react-apollo';
import { Query } from 'react-apollo';

import submissionAttemptQuery from 'bundles/grading/api/SubmissionAttemptQuery.graphql';
import type { SubmissionAttemptQuery, SubmissionAttemptQueryVariables } from 'bundles/grading/api/types';

type Props = {
  variables: SubmissionAttemptQueryVariables;
  children: (result: QueryResult<SubmissionAttemptQuery, SubmissionAttemptQueryVariables>) => React.ReactElement | null;
};

const SubmissionAttemptQueryWrapper: React.FC<Props> = ({ variables, children }) => {
  return (
    <Query<SubmissionAttemptQuery, SubmissionAttemptQueryVariables>
      query={submissionAttemptQuery}
      variables={variables}
      context={{ clientName: 'gatewayGql' }}
    >
      {children}
    </Query>
  );
};

export default SubmissionAttemptQueryWrapper;
